import { useQuery } from '@tanstack/react-query'
import {
  ShiftNoticeTimeseries,
  getShiftNoticeTimeseries,
} from 'api/pulse/shiftNoticeTimeseries'
import { PulseFilters } from 'api/pulse'
import { getShiftNoticeTimeseriesKey } from './keys'
import { PULSE_QUERY_OPTIONS } from './constants'

export function useShiftNoticeTimeseries(query: PulseFilters) {
  return useQuery<ShiftNoticeTimeseries>({
    ...PULSE_QUERY_OPTIONS,
    queryKey: getShiftNoticeTimeseriesKey(query),
    queryFn: ({ signal }) => getShiftNoticeTimeseries(query, signal),
    enabled: !!query.companyIds?.length,
  })
}
